import {Filter} from "@/dto/Pageable";
import {IEmployment} from "@/dto/payroll/IEmployment";
import InvoiceDTO from "@/dto/InvoiceDTO";
import AddressDTO from "@/dto/AddressDTO";
import {IProfile} from "@/dto/IProfile";
import BranchDto, {Branch} from "@/components/profile/branches/BranchDtos";
import {ProjectDTO} from "@/dto/payroll/ProjectDTOs";
import {AccountType} from "@/constants/AccountTypes";

export interface ServiceDTO {
    id: number;
    name: string;
    description?: string | null;
    price: number;
    formattedPrice: string;
    salable: boolean;
    schedule: boolean;
    salesRate?: number;
    active: boolean;
    coefficient: string | null
    holder: IProfile
}

export class SelectableServiceLogDTO implements ServiceRecordDTO {
    id!: number;
    serviceId!: number;
    title!: string;
    price!: number;
    formattedPrice!: string;
    coefficient?: number;
    executor!: IProfile;
    recipient!: IProfile
    location!: string;
    state!: string;
    salable!: boolean;
    schedule!: boolean;
    salesRate!: number;
    active!: boolean;
    description: string | null | undefined = null;
    startDate: string | null = null
    endDate: string | null = null;
    formattedCoefficient?: string;
    total!: number
    formattedTotal!: string;
    formattedSalesRate!: string;
    selected = false;

    constructor(service: ServiceRecordDTO) {
        this.id = service.id
        this.serviceId = service.serviceId
        this.title = service.title
        this.price = service.price
        this.formattedPrice = service.formattedPrice
        this.coefficient = service.coefficient
        this.executor = service.executor
        this.recipient = service.recipient
        this.location = service.location
        this.state = service.state
        this.salable = service.salable
        this.schedule = service.schedule
        this.salesRate = service.salesRate
        this.active = service.active
        this.description = service.description
        this.startDate = service.startDate
        this.total = service.total
        this.endDate = service.endDate
        this.formattedCoefficient = service.formattedCoefficient
        this.formattedTotal = service.formattedTotal
        this.formattedSalesRate = service.formattedSalesRate
    }
}

export class ServiceFilter implements Filter{
    holderId: number | null = null;
    refId: number | null = null;
    name: string | null = null;
    salable: boolean | null = null;
    schedule: boolean | null = null;
    active: boolean | null = null;
    page = 0;
    size = 20;

    constructor(init?: Partial<ServiceFilter>) {
        Object.assign(this, init);
    }
}

export class CreateServicePayload {
    companyId: number | null = null;
    personId: number | null = null;
    name: string | null = null;
    description: string | null = null;
    price: number | null = null;
    taxExempt = false;
    scheduled = false;
    coefficient: number | null = null;

    constructor(init?: Partial<CreateServicePayload>) {
        Object.assign(this, init);
    }
}

export class UpdateServicePayload {
    serviceId: number | null = null;
    holderId: number | null = null;
    name: string | null = null;
    description: string | null = null;
    price: number | null = null;

    constructor(init?: Partial<UpdateServicePayload>) {
        Object.assign(this, init);
    }
}

export class ServiceRecordDTO {
    id!: number;
    serviceId!: number;
    title!: string;
    price!: number;
    formattedPrice!: string;
    coefficient?: number;
    executor!: IProfile;
    recipient!: IProfile
    location!: string;
    state!: string;
    salable!: boolean;
    schedule!: boolean;
    salesRate!: number;
    active!: boolean;
    description: string | null | undefined = null;
    startDate: string | null = null
    endDate: string | null = null;
    formattedCoefficient?: string;
    formattedTotal!: string;
    total!: number
    formattedSalesRate!: string;
}

export type InvoiceSearchMode = "REF" | "CREATOR"

export class InvoiceContactFilter {
    readonly createdBy: number | null = null;
    searchMode: InvoiceSearchMode = "REF"
    query: string | null = null;

    page = 0;
    size = 15;

    constructor(init?: Partial<InvoiceContactFilter>) {
        Object.assign(this, init);
    }
}

/**
 *  id: number | null,
 *     userId: number | null,
 *     phone: string | null,
 *     name: string | null,
 *     tin: string | null,
 *     email: string | null,
 *     client: boolean | null,
 *     type: AccountType | null
 */

export class InvoiceContact implements IProfile{
    readonly id!: number
    readonly userId: number | null = null
    readonly tin: string | null = null
    readonly client: boolean | null = null
    readonly type: AccountType | null = null
    readonly phone: string | null = null
    //ref
    readonly name!: string
    readonly email!: string
    readonly address?: AddressDTO
    readonly ref?: number
    readonly refUserId?: number
    readonly refType?: string
    //ref

    readonly createdBy!: IProfile

    constructor(init?: Partial<InvoiceContact>) {
        Object.assign(this, init);
    }
}

export class ServiceRecordFilter {
    serviceId: number | null = null;
    location: string | null = null;
    active: boolean | null = null;
    startDate: Date | string | null = null;
    endDate: Date | string | null = null
    executorId: number | null = null;
    state: string | null = null;
    recipientId: number | null = null;
    page = 0;
    size = 20;

    constructor(init?: Partial<ServiceRecordFilter>) {
        Object.assign(this, init);
    }
}

export class UpdateServiceRecordPayload {
    id: number | null = null;
    serviceId: number | null = null;
    startDate: Date | string | null = null;
    endDate: Date | string | null = null;
    branchId: number | null = null;
    projectId: number | null = null;
    addressId: number | null = null;
    assigneeId: number | null = null;
    description: string | null = null;

    constructor(init?: Partial<UpdateServiceRecordPayload>) {
        Object.assign(this, init);
    }
}

export class CreateServiceRecordPayload {
    serviceId: number | null = null;
    startDate: Date | string | null = null;
    endDate: Date | string | null = null;
    coefficient: string | null = null;

    salesRate: number | null = null;
    branchId: number | null = null;
    projectId: number | null = null;
    addressId: number | null = null;

    executorId: number | null = null;
    executorCompanyId: number | null = null;
    executorPersonId: number | null = null;

    state: string | null = null;
    assigneeId: number | null = null;
    description: string | null = null;
    recipientId: number | null = null;

    constructor(init?: Partial<CreateServiceRecordPayload>) {
        Object.assign(this, init);
    }
}

export class UpdateAssigneePayload {
    assigneeId: number | null = null;
    companyId: number | null = null;
    serviceId: number | null = null;
}

export interface LocationOption {

    title(): string

    address(): string | null

    selected(req: CreateServiceRecordPayload | UpdateServiceRecordPayload): void
}

export class BranchLocationOption implements LocationOption {
    value: BranchDto

    title(): string {
        return this.value.title!
    }

    address(): string | null {
        if (this.value.address) {
            return this.value.address?.fullAddress
        } else {
            return null
        }
    }

    public selected(req: CreateServiceRecordPayload | UpdateServiceRecordPayload) {
        req.projectId = null
        req.branchId = this.value.id;
        req.addressId = null
    }

    constructor(value: BranchDto) {
        this.value = value
    }

    public static of(value: BranchDto): BranchLocationOption {
        return new BranchLocationOption(value)
    }
}

export class ProjectLocationOption implements LocationOption {
    value: ProjectDTO

    title(): string {
        return this.value.title
    }

    address(): string | null{
        if (this.value.address) {
            return this.value.address.fullAddress
        } else {
            return null
        }
    }

    selected(req: CreateServiceRecordPayload | UpdateServiceRecordPayload): void {
        req.branchId = null
        req.projectId = this.value.id;
        req.addressId = null
    }

    constructor(value: ProjectDTO) {
        this.value = value
    }

    public static of(value: ProjectDTO): ProjectLocationOption {
        return new ProjectLocationOption(value)
    }
}

export class AddressLocationOption implements LocationOption {
    value: AddressDTO;

    title(): string {
        return "Address"
    }

    address(): string {
        return this.value.fullAddress!
    }

    selected(req: CreateServiceRecordPayload | UpdateServiceRecordPayload): void {
        req.branchId = null
        req.projectId = null;
        req.addressId = this.value.id
    }

    constructor(value: AddressDTO) {
        this.value = value
    }

    public static of(value: AddressDTO): AddressLocationOption {
        return new AddressLocationOption(value)
    }
}

export type ServiceInvoiceStatus = 'VOIDED' | 'PAID' | 'IN_PROGRESS' | 'DRAFT'

export class InvoiceSummary {
    payee!: number
    payer!: number
}

export class ServiceInvoice {
    id!: number;
    contractor!: IEmployment;
    payee!: IProfile
    payer!: IProfile
    logs!: ServiceRecordDTO[];
    invoice: InvoiceDTO | null = null;
    total!: string;
    status!: ServiceInvoiceStatus;
    startDate!: Date | string | null
    endDate!: Date | string | null
}

export class CreateInvoicePayload {
    payeeId: number | null = null;
    payerId: number | null = null;
    serviceLogs: number[] | null = null
    startDate: Date | string | null = null
    endDate: Date | string | null = null
    dueDays = 7
}

export class UpdateDraftInvoicePayload {
    id: number | null = null
    payeeId: number | null = null;
    payerId: number | null = null;
    serviceLogs: number[] | null = null
    status: ServiceInvoiceStatus | null = null
    dueDays = 7
}

export class UpdateInvoicePayload {
    serviceInvoiceId: number | null = null
    payerId: number | null = null
    payeeId: number | null = null
    status: ServiceInvoiceStatus | null = null

    constructor(init?: Partial<UpdateInvoicePayload>) {
        Object.assign(this, init);
    }
}

export class ServiceInvoiceFilter implements Filter{
    payerId: number | null = null;
    payeeId: number | null = null;
    participantId: number | null = null;
    status: ServiceInvoiceStatus | null = null
    excludeStatus: ServiceInvoiceStatus | null = null
    startDate: Date | string | null = null
    endDate: Date | string | null = null
    page = 0;
    size = 20;

    constructor(init?: Partial<ServiceInvoiceFilter>) {
        Object.assign(this, init);
    }
}

export class CreateInvoiceContactPayload {
    name: string | null = null;
    email: string | null = null;
    address: AddressDTO | null = null;
    createdBy: number | null = null;

    constructor(init?: Partial<CreateInvoiceContactPayload>) {
        Object.assign(this, init);
    }
}

export class Locations {
    branches: Array<BranchDto> = []
    projects: Array<ProjectDTO> = []
    addresses: Array<AddressDTO> = []
}